/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import React from "react"
import ReactMarkdown from "react-markdown"
import { Link } from "react-router-dom"

import * as S from "./style"
import { ReactComponent as UnderageSVG } from "../../assets/icons/social/18.svg"
import { ReactComponent as FacebookSVG } from "../../assets/icons/social/facebook.svg"
import { ReactComponent as InstagramSVG } from "../../assets/icons/social/instagram.svg"
import { ReactComponent as TwitterSVG } from "../../assets/icons/social/x-icon.svg"

const Footer = ({ footerLogo, footerDisclaimer, legalLinks, ourSitesLinks, socialLinks, navLinks, translations }) => (
  <S.Footer>
    <S.FooterLogo src={footerLogo.url} alt="Leovegas" />
    <S.Inner>
      <S.NavigationItems>
        <S.Section>
          <h3>{translations.navigation}</h3>
          <ul>
            {navLinks.map(link => (
              <li key={link.text}>
                <Link to={link.to}>{link.text}</Link>
              </li>
            ))}
          </ul>
        </S.Section>
        <S.Section>
          <h3>{translations.legal}</h3>
          <ul>
            {legalLinks
              .sort((a, b) => a.label.localeCompare(b.label))
              .map(({ slug, label }, index) => (
                <li key={index}>
                  <Link to={`./${slug}`}>{label}</Link>
                </li>
              ))}
          </ul>
        </S.Section>
        <S.Section>
          <h3>{translations.ourSites}</h3>
          <ReactMarkdown>{ourSitesLinks}</ReactMarkdown>
        </S.Section>
      </S.NavigationItems>
      <hr />
      <S.SocialLinksSection>
        {socialLinks && (
          <>
            {socialLinks[0] && (
              <S.SocialMediaLink href={socialLinks[0].url} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FacebookSVG alt="facebook" />
              </S.SocialMediaLink>
            )}
            {socialLinks[1] && (
              <S.SocialMediaLink href={socialLinks[1].url} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <TwitterSVG alt="twitter" />
              </S.SocialMediaLink>
            )}
            {socialLinks[2] && (
              <S.SocialMediaLink href={socialLinks[2].url} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <InstagramSVG alt="instagram" />
              </S.SocialMediaLink>
            )}
          </>
        )}
        <S.SocialMediaIcon href="#" target="_blank" rel="noopener noreferrer" aria-label="Underage">
          <UnderageSVG alt="underage" />
        </S.SocialMediaIcon>
      </S.SocialLinksSection>
      <hr />
      <S.footerDisclaimer>
        <ReactMarkdown>{footerDisclaimer}</ReactMarkdown>
      </S.footerDisclaimer>
    </S.Inner>
  </S.Footer>
)

export default Footer
